import { useState, useContext, useEffect } from "react";
import {
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import { AuthContext } from "../../../context/AuthContext";

const CreateProjectDialog = ({
  companyId,
  open,
  defaultProjectName = "",
  handleClose,
  onSuccess,
}) => {
  const navigate = useNavigate();
  const { authToken, ezorder } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const formValidationSchema = Yup.object({
    name: Yup.string().required("Project Name is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: defaultProjectName,
    },
    validationSchema: formValidationSchema,
    validateOnBlur: false,
    validateOnChange: true,
    onSubmit: (values) => {
      console.log("SUBMITTED", values);
      createProject(values);
    },
  });

  const createProject = async (requestBody) => {
    try {
      setLoading(true);
      setErrorMessage("");
      const response = await ezorder.post(
        `/admin/companies/${companyId}/projects`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.status == 200 || response.status == 201) {
        onSuccess(response.data.project);
      } else {
        setErrorMessage(response.response.data.error);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        setErrorMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        setErrorMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={() => {
        handleClose();
      }}
    >
      <DialogTitle>Add New Project</DialogTitle>
      <DialogContent>
        <TextField
          sx={{ marginTop: "8px" }}
          size="small"
          fullWidth
          id="name"
          label="Project Name *"
          name="name"
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.name &&
            formik.errors.name &&
            Boolean(formik.errors.name && true)
          }
          helperText={
            formik.touched.name && formik.errors.name && `${formik.errors.name}`
          }
        />
        <Box sx={{ marginTop: "16px" }}>
          {errorMessage && (
            <Box>
              <Typography color={"red"}>{errorMessage}</Typography>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          loading={loading}
          onClick={() => {
            handleClose();
          }}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          loading={loading}
          variant="contained"
          color="primary"
          onClick={() => {
            formik.handleSubmit();
          }}
        >
          Submit
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default CreateProjectDialog;
